module.exports = __webpack_public_path__ + "img/noominuhk_logo.eb4e5418.png";